import { createActions } from 'redux-actions';

const actions = createActions({
  SESSION: {
    LOGIN: (username, password) => ({ username, password }),
    LOGIN_SUCCESS: (idToken) => ({ idToken }),
    LOGIN_FAILED: (error) => ({ error }),
    NEW_PASSWORD_REQUIRED: (user, attributes) => ({ user, attributes }),
    SUBMIT_NEW_PASSWORD: (newPassword, attributes) => ({ newPassword, attributes }),
    UNAUTHORISED: undefined,
    REMOVE_ID_TOKEN: undefined
  }
});

export default actions;



// WEBPACK FOOTER //
// ./src/state/modules/session/actions.js